var _path, _path2, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import { forwardRef } from "react";

const SvgEmptyTimesheet = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 60,
    viewBox: "0 0 50 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M25.25 11.25C11.7875 11.25 0.875 22.1625 0.875 35.625C0.875 49.0875 11.7875 60 25.25 60C38.7125 60 49.625 49.0875 49.625 35.625C49.625 22.1625 38.7125 11.25 25.25 11.25ZM29 39.375C29 39.8723 28.8025 40.3492 28.4508 40.7008C28.0992 41.0525 27.6223 41.25 27.125 41.25H23.375C22.8777 41.25 22.4008 41.0525 22.0492 40.7008C21.6975 40.3492 21.5 39.8723 21.5 39.375V24.4336C21.5 23.9363 21.6975 23.4594 22.0492 23.1078C22.4008 22.7561 22.8777 22.5586 23.375 22.5586H27.125C27.6223 22.5586 28.0992 22.7561 28.4508 23.1078C28.8025 23.4594 29 23.9363 29 24.4336V39.375Z",
    fill: "url(#paint0_linear)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.125 22.5586H23.375C22.8777 22.5586 22.4008 22.7561 22.0492 23.1078C21.6975 23.4594 21.5 23.9363 21.5 24.4336V39.375C21.5 39.8723 21.6975 40.3492 22.0492 40.7008C22.4008 41.0525 22.8777 41.25 23.375 41.25H27.125C27.6223 41.25 28.0992 41.0525 28.4508 40.7008C28.8025 40.3492 29 39.8723 29 39.375V24.4336C29 23.9363 28.8025 23.4594 28.4508 23.1078C28.0992 22.7561 27.6223 22.5586 27.125 22.5586ZM49.2184 16.8668L45.902 13.5504C45.7713 13.4193 45.6161 13.3153 45.4451 13.2443C45.2742 13.1733 45.0909 13.1368 44.9059 13.1368C44.7208 13.1368 44.5375 13.1733 44.3666 13.2443C44.1957 13.3153 44.0404 13.4193 43.9098 13.5504L40.693 16.7672C42.643 18.3653 44.3348 20.2547 45.7086 22.3688L45.773 22.3043L49.2184 18.859C49.3495 18.7283 49.4535 18.5731 49.5245 18.4022C49.5954 18.2312 49.632 18.048 49.632 17.8629C49.632 17.6778 49.5954 17.4945 49.5245 17.3236C49.4535 17.1527 49.3495 16.9974 49.2184 16.8668ZM31.8125 0H18.6875C18.1902 0 17.7133 0.197544 17.3617 0.549175C17.01 0.900806 16.8125 1.37772 16.8125 1.875V5.625C16.8125 6.12228 17.01 6.59919 17.3617 6.95083C17.7133 7.30246 18.1902 7.5 18.6875 7.5H21.5V11.5371C23.9853 11.1539 26.5147 11.1539 29 11.5371V7.5H31.8125C32.3098 7.5 32.7867 7.30246 33.1383 6.95083C33.49 6.59919 33.6875 6.12228 33.6875 5.625V1.875C33.6875 1.37772 33.49 0.900806 33.1383 0.549175C32.7867 0.197544 32.3098 0 31.8125 0V0Z",
    fill: "url(#paint1_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 25.25,
    y1: 11.25,
    x2: 25.25,
    y2: 60,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9AA0AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D0D3DA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 33.2222,
    y1: 0,
    x2: 33.2222,
    y2: 41.25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9AA0AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D0D3DA"
  })))));
};

const ForwardRef = /*#__PURE__*/forwardRef(SvgEmptyTimesheet);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/empty-timesheet.e3d5be1f570ea2add9bcb74197da4758.svg";